import { useEffect, useState } from "react";

const ema = (a: number, b: number, alpha: number): number =>
  alpha * b + (1 - alpha) * a;

export const useFps = (intervalMs = 500): number => {
  const [fps, setFps] = useState<number>(60);

  useEffect(() => {
    let frames = 0;
    let last = performance.now();
    let rafId = 0;
    let smoothed = 60;

    const tick = (now: number): void => {
      frames += 1;
      if (now - last >= intervalMs) {
        const inst = (frames * 1000) / (now - last);
        smoothed = ema(smoothed, inst, 0.25);
        setFps(Math.round(smoothed));
        frames = 0;
        last = now;
      }
      rafId = requestAnimationFrame(tick);
    };

    rafId = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(rafId);
  }, [intervalMs]);

  return fps;
};
